<script setup>
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  cards: { type: Array, default: () => [] },
});

const getHeaderUrl = card => {
  if (card.mediaUrl) return card.mediaUrl;
  if (card.mediaFile instanceof File)
    return URL.createObjectURL(card.mediaFile);
  return null;
};
</script>

<template>
  <div class="carousel-preview w-full overflow-x-auto py-4">
    <div class="flex gap-4 px-1 min-w-max">
      <div
        v-for="(card, index) in cards"
        :key="index"
        class="p-3 w-64 bg-white rounded-lg shadow-sm border border-slate-100 overflow-hidden flex flex-col"
      >
        <div
          class="h-32 bg-gray-200 flex items-center justify-center overflow-hidden rounded-xl"
        >
          <img
            v-if="card.headerType === 'IMAGE'"
            :src="
              getHeaderUrl(card) ||
              'https://via.assets.so/img.jpg?w=400&h=300&bg=e5e7eb&text=IMAGE&f=png'
            "
            class="w-full h-full object-cover"
          />
          <div
            v-else-if="card.headerType === 'VIDEO'"
            class="flex flex-col items-center text-gray-400"
          >
            <video
              v-if="getHeaderUrl(card)"
              :src="getHeaderUrl(card)"
              class="w-full h-full object-cover"
              controls
            />
            <div v-else class="flex flex-col items-center">
              <!-- eslint-disable-next-line vue/no-bare-strings-in-template -->
              <span class="text-2xl">🎥</span>
              <!-- eslint-disable-next-line vue/no-bare-strings-in-template -->
              <span class="text-xs">VIDEO</span>
            </div>
          </div>
        </div>
        <div class="p-3 flex-grow">
          <p class="text-sm text-gray-800 whitespace-pre-wrap">
            {{ card.body || 'Card body text...' }}
          </p>
        </div>
        <div class="flex flex-col gap-3">
          <Button
            v-for="(button, bIndex) in card.buttons"
            :key="bIndex"
            color="blue"
            variant="faded"
            trailing-icon
            class="!px-3 !py-3"
            :label="button.text || 'Button'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.carousel-preview::-webkit-scrollbar {
  height: 6px;
}
.carousel-preview::-webkit-scrollbar-track {
  background: transparent;
}
.carousel-preview::-webkit-scrollbar-thumb {
  background-color: gray;
  border-radius: 3px;
}
</style>
